<template>
  <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <div id="app">
    <keep-alive><router-view v-if="$route.meta.keepAlive"/></keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'App'
}
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html, body {
  margin: 0;
  padding: 0;
  height: 100%; /* 设置HTML文档的高度为100% */
  background-color: white;
  overflow-x: hidden; /* 防止水平滚动条 */
}
/* 隐藏滚动条，但仍可正常滚动（兼容主流浏览器） */
/* 针对 WebKit 内核浏览器（Chrome、Safari 等） */
::-webkit-scrollbar {
  width: 0; /* 宽度设为 0，隐藏垂直滚动条 */
  height: 0; /* 高度设为 0，隐藏水平滚动条 */
}

/* 针对 Firefox */
/* Firefox 需通过配置隐藏，注意：Firefox 64+ 支持 scrollbar-width */
.scroll-container {
  scrollbar-width: none; /* 隐藏滚动条 */
  -ms-overflow-style: none; /* 针对 IE 和 Edge */
}
</style>
